export default "__VITE_ASSET__DJxb3QvE__"